module.exports = __webpack_public_path__ + "media/images/page/top/top_img_04-5fe2f7301d4ec8487b6a6830f46289e8.png";